import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, JsonPipe],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('client-app');
  protected loading = signal(false);
  protected response = signal<any>(null);
  protected error = signal<string | null>(null);

  constructor(private http: HttpClient) {}

  makeRequest(url: string) {
    this.loading.set(true);
    this.response.set(null);
    this.error.set(null);

    console.log('Making request to:', url);

    this.http.get(url).subscribe({
      next: (data) => {
        console.log('Request successful:', data);
        this.loading.set(false);
        this.response.set(data);
      },
      error: (err) => {
        console.error('Request failed:', err);
        this.loading.set(false);

        let errorMessage = 'Unknown error';

        if (err.status === 0) {
          errorMessage =
            'CORS error or network issue. The API server might not allow requests from this origin (localhost:4200), or there might be an HTTPS certificate issue.';
        } else if (err.status) {
          errorMessage = `HTTP ${err.status}: ${err.statusText || err.message}`;
        } else if (err.message) {
          errorMessage = err.message;
        }

        this.error.set(`Error: ${errorMessage}`);
      },
    });
  }
}
